module.exports = __webpack_public_path__ + "static/026-c00a9468a557ef939281ca71b188c3d3.png";